<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <!-- <v-row class="centered">
      <v-col cols="12" class="centered"
        ><PlayButton info="true" :src="youtubeVideoOne"
      /></v-col>
      <v-col cols="12" md="1" class="centered"
        ><PlayButton :src="youtubeVideoTwo" :title="'Sheperd'"
      /></v-col>
      <v-col cols="12" md="1" class="centered"
        ><PlayButton :src="youtubeVideoThree" :title="'Overstreet'"
      /></v-col>
      <v-col cols="12" md="1" class="centered"
        ><PlayButton :src="youtubeVideoFour" :title="'Winslow'"
      /></v-col>
    </v-row> -->
    <!-- <v-row class="centered"><PlayButton :src="youtubeVideoOne"/></v-row>
    <v-row class="centered"><PlayButton :src="youtubeVideoTwo"/></v-row>
    <v-row class="centered"><PlayButton :src="youtubeVideoThree"/></v-row> -->
    <v-row align="center" justify="center">
      <v-col align="center" justify="center" :cols="columns" style="margin-top: 3%;">
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" eager />
        <v-img src="../../public/static/slides/Welcome.jpg" eager width="80%" />
        <v-img src="../../public/static/Easel Bottom.png" :width="easelBottom" eager />
      </v-col>
      <v-col>
        <v-row>
          <v-col align="center" justify="center" cols="12">
            <v-card class="slide-card" style="max-width: 90%;">
              <!-- <v-img
                src="../../public/static/Campbellton Logo.jpg"
                contain
                width="50%"
              /> -->
              <div class="slide-content">
                <h1 id="header" style="font-size: 24px">
                  Welcome
                </h1>
                <p>Learn more about the <strong>Campbellton Community Investment
                    Corridor Project: A Main Street for Southwest Atlanta.</strong></p>

                <p>
                  Thank you for visiting the Virtual Meeting Room (VMR) for the
                  Campbellton Corridor Transit project.
                </p>
                <p>
                  The VMR showcases poster boards, videos, documents, and more,
                  allowing visitors to learn about the project at their own pace
                  and leisure. To look at prior public meetings go to
                  <a href="https://www.youtube.com/channel/UCQYQDb3n5HakxG-9GVN8Mgw" target="a_blank">
                    MARTA's YouTube page</a>.
                </p>
                <h2 id="secondary-header">
                  Here are some helpful tips to navigate the Virtual Meeting
                  Room:
                </h2>
                <ul id="list-items">
                  <li>
                    The following browsers are recommended for the site: Chrome,
                    Firefox, Safari, or Edge.
                  </li>
                  <li>
                    Click the left or right arrow on each side of your screen or
                    select your station of choice from the navigation bar below.
                  </li>
                  <li>
                    This VMR is interactive. Click on the displays and buttons
                    for additional information in each station.
                  </li>
                  <!-- <li>
                    <b style="color: red;">The public comment period is now closed.</b>
                  </li> -->
                  <li>
                    To request this information in another language or in an
                    accessible format, call 404-848-4037 or 404-848-5665 (TTY).
                  </li>
                  <li>
                    For project specific questions, email Marcus Arnold at
                    <a href="mailto:marnold-vhb@itsmarta.com">
                      marnold-vhb@itsmarta.com</a>
                  </li>
                  <li>
                    For all other questions, contact Customer Service at
                    <a href="mailto:custserv@itsmarta.com">
                      custserv@itsmarta.com</a>
                    or call 404-848-5000.
                  </li>
                </ul>
              </div>
              <!-- <v-row
                class="flex-sm-wrap"
                align="center"
                justify="center"
                style="margin: 1%;"
              >
                <v-col
                  align="center"
                  justify="center"
                  :cols="columns"
                  style="margin-top: 1%;"
                >
                  <SignupButton text="Bus Tour Registration" type="busTour" />
                </v-col>
                <v-col
                  align="center"
                  justify="center"
                  :cols="columns"
                  style="margin-top: 1%;"
                >
                  <BigButton
                    text="Virtual Meeting Registration"
                    url="https://zoom.us/webinar/register/WN_b0mtTrqWSkOmKxvf-bqzYw"
                  />
                </v-col>
              </v-row> -->
              <!-- <MeetingReminderModal /> -->
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
// import PlayButton from "./common/PlayIcon.vue";
// import SignupButton from "@/components/SignupButton.vue";
// import BigButton from "@/components/BigButton";
// import MeetingReminderModal from "./MeetingReminderModal.vue";

export default {
  name: "Welcome",
  components: {
    // PlayButton,
    // SignupButton,
    // BigButton
    // MeetingReminderModal
  },
  data: () => ({
    // asset pending
    youtubeVideoOne:
      "https://campbellton-files.s3.us-east-2.amazonaws.com/camp_how_to.mp3",
    youtubeVideoTwo: "https://www.youtube.com/embed/UgLAkrTDAcw",
    youtubeVideoThree: "https://www.youtube.com/embed/JorlEYU2YMc",
    youtubeVideoFour: "https://www.youtube.com/embed/NO6K6P-VffM",
    showVideoDialog: false
  }),
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "10%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "50%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleVideoDialog() {
      this.showVideoDialog = !this.showVideoDialog;
    }
  }
};
</script>

<style scoped>
.centered {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}

.slide-content {
  text-align: justify;
  font-family: sans-serif;
  /* font-size: 1rem; */
  font-size: 12px;
}
</style>
